<template>
  <div class="dashboard-page dp-page">
    <div class="mb-5">
      <h1 class="dp-page-title">Dashboard Monitoring Perizinan</h1>
      <span class="dp-desc">Statistik dan analisis permohonan kesesuaian kegiatan pemanfaatan ruang laut</span>
    </div>
    
    <div class="sidesWrapper">
      <div style="width: 100%">
        <b-tabs nav-class="dp-page-tabs bg-transparent">
          <!-- ============ TAB PERMOHONAN ============ -->
          <b-tab active>
            <template #title>
              <svg class="dp-page-tab-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
              Permohonan
            </template>

            <div class="dp-page-toolbar">
              <div class="dp-page-filter-group">
                <label for="filter_tahun1" class="dp-page-filter-label">Pilih Periode:</label>
                <div class="dp-page-select-wrap">
                  <select v-model="filter_tahun" id="filter_tahun1" class="dp-page-select">
                    <option v-for="d in optionTahun" :key="d" :value="d">{{ d }}</option>
                  </select>
                  <span class="dp-page-select-arrow" aria-hidden="true">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                      stroke-linejoin="round">
                      <path d="m6 9 6 6 6-6" />
                    </svg>
                  </span>
                </div>
              </div>

              <button type="button" class="dp-page-btn dp-page-btn-export" @click="exportData">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                  stroke-linejoin="round" aria-hidden="true">
                  <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                  <polyline points="7 10 12 15 17 10" />
                  <line x1="12" x2="12" y1="15" y2="3" />
                </svg>
                Ekspor Laporan
              </button>
            </div>

            <DashboardPerizinan :filter-tahun="filter_tahun" />
          </b-tab>

          <!-- ============ TAB PEMUTAKHIRAN ============ -->
          <b-tab>
            <template #title>
              <svg class="dp-page-tab-ic" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
                <path d="M3 3v5h5" />
                <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
                <path d="M16 21h5v-5" />
              </svg>
              Pemutakhiran
            </template>

            <div class="dp-page-toolbar">
              <div class="dp-page-select-wrap">
                <select v-model="filter_tahun_pemutakhiran" id="filter_tahun_pemutakhiran" class="dp-page-select"
                  aria-label="Pilih periode pemutakhiran">
                  <option value="semua">Semua Tahun</option>
                  <option v-for="d in optionTahun" :key="d" :value="d">{{ d }}</option>
                </select>
                <span class="dp-page-select-arrow" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </span>
              </div>
            </div>

            <PemutakhiranMain :data-pemutakhiran="dataPemutakhiran"
              :filter-tahun-pemutakhiran="filter_tahun_pemutakhiran" />

            <div class="row mt-4">
              <div class="col-12">
                <PemutakhiranPerubahanKkprl :tahun="filter_tahun_pemutakhiran" />
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import IzinPNBPChart from './components/MainChartV2/IzinPNBPChart.vue'
import IzinProvChart from './components/MainChartV2/IzinProvChart.vue'
import IzinSektorChart from './components/MainChartV2/IzinSektorChart.vue'
import PermohonanProvChart from './components/MainChartV2/PermohonanProvChart.vue'
import PermohonanSektorChart from './components/MainChartV2/PermohonanSektorChart.vue'
import PermohonanMain from './components/MainChartV2/PermohonanMain.vue'
import IzinMain from './components/MainChartV2/IzinMain.vue'
import PemutakhiranMain from './components/MainChartV2/PemutakhiranMain.vue'
import PemutakhiranPerubahanKkprl from './components/MainChartV2/PemutakhiranPerubahanKkprl.vue'
import DashboardPerizinan from './DashboardPerizinan.vue'

export default {
  components: {
    PermohonanMain,
    PermohonanProvChart,
    PermohonanSektorChart,
    IzinMain,
    IzinProvChart,
    IzinSektorChart,
    IzinPNBPChart,
    PemutakhiranMain,
    PemutakhiranPerubahanKkprl,
    DashboardPerizinan
  },
  data() {
    return {
      baseapi: localStorage.getItem('baseapi'),
      user: JSON.parse(localStorage.getItem('user')),
      filter_tahun: new Date().getFullYear(),
      filter_tahun_pemutakhiran: new Date().getFullYear(),
      filter_bulan: new Date().getMonth() + 1,
      dataPenerbitan: {

      },
      dataPemutakhiran: {
        jumlah_penerbitan_izin: 0,
        habis_masa_berlaku: 0,
        pencabutan: 0,
        pembatalan: 0,
      },
    }
  },
  methods: {
    // async loadDataPenerbitan() {
    //   const configAxios = {
    //     headers: {
    //       Authorization: `Bearer ` + this.user.accessToken,
    //     },
    //   }
    //   try {
    //     const res = (
    //       await axios.get(
    //         `${this.baseapi}api/dashboard/getJumlahPermohonanNew?tahun=${this.filter_tahun}`,
    //         configAxios,
    //       )
    //     ).data.data
    //     // const res2 = (
    //     //   await axios.get(
    //     //     `${this.baseapi}api/dashboard/getJumlahPermohonanPNBP?tahun=${this.filter_tahun}`,
    //     //     configAxios,
    //     //   )
    //     // ).data.data
    //     // const res3 = (
    //     //   await axios.get(
    //     //     `${this.baseapi}api/dashboard/getJumlahPenerbitanIzin?tahun=${this.filter_tahun}`,
    //     //     configAxios,
    //     //   )
    //     // ).data.data
    //     this.dataPenerbitan = {
    //       ...this.dataPenerbitan
    //     }
    //   } catch (error) {}
    // },
    async loadCapaianPNBP(val) {
      if (val) this.filter_bulan = val
      const res = (
        await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPNBP?tahun=${this.filter_tahun}&bulan=${this.filter_bulan}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
      ).data.data
      this.dataPenerbitan = {
        ...this.dataPenerbitan,
        capaian_pnbp: res,
      }
    },
    async loadDataPemutakhiran() {
      try {
        const res = await axios.get(
          `${this.baseapi}api/dashboard/getJumlahPemuktahiran${this.filter_tahun_pemutakhiran == 'semua' ? '' : `?tahun=${this.filter_tahun_pemutakhiran}`}`,
          {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken,
            },
          },
        )
        this.dataPemutakhiran = res.data.data
      } catch (error) { }
    },
    async exportData() {
    try {
      this.$loading(true, 'Mengekspor data...'); // Menampilkan loading indicator

      // Contoh pemanggilan API (menggunakan Axios)
      // Pastikan responseType diset 'blob' agar data diterima sebagai binary
      const response = await axios.get(`${this.baseapi}api/dashboard/exportRangkumanPerizinan`, {
        params: {
          tahun: this.filter_tahun // Mengikutkan filter tahun jika diperlukan
        },
        responseType: 'blob' 
      });

      // 1. Buat objek URL dari data Blob yang diterima
      const blob = new Blob([response.data], { 
        type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' 
      });
      const url = window.URL.createObjectURL(blob);

      // 2. Buat elemen <a> sementara untuk memicu proses download browser
      const link = document.createElement('a');
      link.href = url;

      // 3. Tentukan nama file (bisa diambil dari header backend atau nama default)
      // Contoh mengambil nama file dari header Content-Disposition jika disediakan backend
      let filename = `Rangkuman_Perizinan_${this.filter_tahun}.xlsx`; // Nama default
      const disposition = response.headers['content-disposition'];
      if (disposition && disposition.indexOf('filename=') !== -1) {
        const matches = disposition.match(/filename="?([^"]+)"?/);
        if (matches != null && matches[1]) filename = matches[1];
      }

      link.setAttribute('download', filename);

      // 4. Masukkan ke DOM, klik secara otomatis, lalu hapus kembali
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // 5. Bersihkan memori URL objek
      window.URL.revokeObjectURL(url);

    } catch (error) {
      console.error('Gagal mengepor data:', error);
      alert('Terjadi kesalahan saat mengunduh data.');
    } finally {
      this.$loading(false); // Menyembunyikan loading indicator
    }
  }
  },
  computed: {
    optionTahun() {
      const currentYear = new Date().getFullYear()
      return Array.from({ length: 10 }, (_, i) => currentYear - i)
    },
  },
  watch: {
    filter_tahun_pemutakhiran: {
      async handler() {
        // this.loadDataPenerbitan()
        this.loadCapaianPNBP()
        this.loadDataPemutakhiran()
      },
      immediate: true,
    },
  },
}
</script>

<style scoped>
/*
  dashboardPage.css — gaya untuk judul, tab, pilihan periode, dan tombol ekspor halaman induk dashboard.
  Tempel ke <style> komponen halaman (TANPA "scoped": elemen tab dirender oleh b-tabs di luar scope komponen).

  - Semua selector diawali ".dp-page" (kelas yang ditambahkan pada elemen root) dan kelas barunya berawalan
    "dp-page-", jadi tidak bentrok dengan Bootstrap, halaman lain, maupun kelas "dp-*" milik DashboardPerizinan.
  - Font Poppins hanya dipasang pada judul, tab, dan toolbar; isi tab "Pemutakhiran" tidak diubah.
*/

.dp-page {
  --dp-font: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  --dp-primary: #182d70;
  --dp-blue: #0879df;
  --dp-ink: #1e293b;
  --dp-ink-secondary: #475569;
  --dp-muted: #64748b;
  --dp-line: #e2e8f0;
  --dp-shadow-sm: 0 1px 2px 0 rgba(16, 24, 40, 0.04);
}

/* ---------- Judul halaman ---------- */
.dp-page .dp-page-title {
  font-family: var(--dp-font);
  font-size: 28px;
  font-weight: 600;
  letter-spacing: -0.4px;
  color: #0f172a;
}

/* ---------- Tab (garis bawah, bukan pil) ---------- */
.dp-page .dp-page-tabs.nav-tabs {
  display: flex;
  flex-wrap: nowrap;
  gap: 8px;
  margin: 0 0 20px;
  padding: 0;
  border: 0;
  border-bottom: 1px solid var(--dp-line);
  background: transparent;
  overflow-x: auto;
  scrollbar-width: thin;
  font-family: var(--dp-font);
}

.dp-page .dp-page-tabs.nav-tabs .nav-item {
  display: flex;
  margin: 0;
}

.dp-page .dp-page-tabs.nav-tabs .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin: 0 0 -1px;
  padding: 10px 18px;
  border: 0;
  border-bottom: 2px solid transparent;
  border-radius: 0;
  background: transparent;
  color: var(--dp-muted);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s ease;
}

.dp-page .dp-page-tabs.nav-tabs .nav-link:hover,
.dp-page .dp-page-tabs.nav-tabs .nav-link:focus {
  border-color: transparent;
  background: transparent;
  color: var(--dp-primary);
  outline: none;
}

.dp-page .dp-page-tabs.nav-tabs .nav-link:focus-visible {
  outline: 2px solid rgba(8, 121, 223, 0.35);
  outline-offset: -2px;
  border-radius: 6px;
}

/* harus setelah :hover/:focus agar garis bawah tab aktif tidak ikut hilang saat disorot */
.dp-page .dp-page-tabs.nav-tabs .nav-link.active,
.dp-page .dp-page-tabs.nav-tabs .nav-item.show .nav-link {
  border-color: transparent;
  border-bottom-color: var(--dp-primary);
  background: transparent;
  color: var(--dp-primary);
  font-weight: 600;
}

.dp-page .dp-page-tab-ic {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

/* ---------- Toolbar: pilihan periode + tombol ekspor ---------- */
.dp-page .dp-page-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
  font-family: var(--dp-font);
}

.dp-page .dp-page-filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dp-page .dp-page-filter-label {
  margin: 0;
  font-size: 12.5px;
  font-weight: 500;
  color: var(--dp-ink-secondary);
}

.dp-page .dp-page-select-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
}

.dp-page .dp-page-select {
  display: block;
  width: auto;
  height: auto;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding: 8px 36px 8px 12px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff none;
  box-shadow: var(--dp-shadow-sm);
  color: var(--dp-ink);
  font-family: var(--dp-font);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  cursor: pointer;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.dp-page .dp-page-select:focus {
  border-color: var(--dp-blue);
  box-shadow: 0 0 0 3px rgba(8, 121, 223, 0.15);
}

.dp-page .dp-page-select-arrow {
  position: absolute;
  right: 12px;
  display: flex;
  align-items: center;
  color: var(--dp-muted);
  pointer-events: none;
}

.dp-page .dp-page-select-arrow svg {
  width: 14px;
  height: 14px;
}

.dp-page .dp-page-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  padding: 8px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #ffffff;
  box-shadow: var(--dp-shadow-sm);
  color: var(--dp-ink-secondary);
  font-family: var(--dp-font);
  font-size: 13px;
  font-weight: 500;
  line-height: normal;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.15s ease;
}

.dp-page .dp-page-btn svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
}

.dp-page .dp-page-btn:hover {
  border-color: #94a3b8;
  background: #f8fafc;
  color: var(--dp-ink);
}

.dp-page .dp-page-btn:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(8, 121, 223, 0.2);
}

.dp-page .dp-page-btn-export {
  border-color: #10b981;
  background: #ecfdf5;
  color: #047857;
  font-weight: 600;
}

.dp-page .dp-page-btn-export:hover {
  border-color: #059669;
  background: #d1fae5;
  color: #065f46;
}

.dp-desc { font-size: 14px; color: var(--dp-muted); margin-top: 1px; }

/* ---------- Layar kecil ---------- */
@media (max-width: 600px) {
  .dp-page .dp-page-title { font-size: 24px; }
  .dp-page .dp-page-toolbar { align-items: stretch; }
  .dp-page .dp-page-filter-group { justify-content: space-between; }
  .dp-page .dp-page-toolbar .dp-page-btn-export { width: 100%; justify-content: center; }
}

</style>
